import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-product-dashboard-transport',
    templateUrl: './product-dashboard-transport.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDashboardTransportComponent {

}